import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useConfigs } from "../config-provider";
import { getDaysInMonth, chunks } from "./utils";
import Day from "./Day";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(2, 1, 0)
    },
    weekday: {
      width: 36,
      display: "inline-block",
      textAlign: "center"
    }
  };
});

var Month = function Month(_a) {
  var date = _a.date,
      month = _a.month,
      onChange = _a.onChange,
      disableDate = _a.disableDate;
  var classes = useStyles();
  var configs = useConfigs();
  var WEEK_DAYS = React.useMemo(function () {
    return [configs.locale.DatePicker.Sun, configs.locale.DatePicker.Mon, configs.locale.DatePicker.Tue, configs.locale.DatePicker.Wed, configs.locale.DatePicker.Thu, configs.locale.DatePicker.Fri, configs.locale.DatePicker.Sat];
  }, [configs.locale]);
  return React.createElement(Grid, {
    className: classes.root
  }, React.createElement(Grid, null, WEEK_DAYS.map(function (day) {
    return React.createElement(Typography, {
      className: classes.weekday,
      color: "textSecondary",
      key: day,
      variant: "caption"
    }, day);
  })), chunks(getDaysInMonth(month), 7).map(function (week, idx) {
    return React.createElement(Grid, {
      container: true,
      key: idx
    }, week.map(function (day, i) {
      return React.createElement(Day, {
        key: i,
        day: day,
        disabled: disableDate ? disableDate(day) : false,
        selected: day && day.isSame(date, "d"),
        onClick: onChange
      });
    }));
  }));
};

export default Month;